import {
    Box,
    List,
    ListItem,
    ListItemText,
    Stack,
    Typography,
} from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import type { PackageFormValues } from '@/views/add-package/add-package.types';
import { PreviewSectionCard } from '../PreviewSectionCard';

const UnitProductsSection = () => {
    const { control } = useFormContext<PackageFormValues>();
    const products = useWatch({
        control,
        name: 'products',
        defaultValue: [],
    });

    return (
        <PreviewSectionCard title="Unit Products">
            {products.length ? (
                <Stack spacing={2}>
                    {products.map(day => (
                        <Box key={day.day_index}>
                            <Typography variant="body2" color="text.secondary">
                                Day {day.day_index}
                            </Typography>
                            {day.items?.length ? (
                                <List dense sx={{ p: 0 }}>
                                    {day.items.map(product => (
                                        <ListItem
                                            key={product.id}
                                            sx={{ px: 0 }}
                                        >
                                            <ListItemText
                                                primary={product.name}
                                                secondary={`Start time: ${
                                                    product.start_time || '—'
                                                }`}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            ) : (
                                <Typography variant="body2">—</Typography>
                            )}
                        </Box>
                    ))}
                </Stack>
            ) : (
                <Typography variant="body2">—</Typography>
            )}
        </PreviewSectionCard>
    );
};

export default UnitProductsSection;
